<template>
  <!-- 购前必读部分 -->
  <div class="tips">
    <!-- 左侧标题以及序号部分 -->
    <div class="left">
      <!-- 序号部分 -->
      <div class="number">{{ MYnumber }}</div>
      <!-- 类型部分 -->
      <div class="type" v-if="this.type != null">{{type}}</div>
      <!-- 标题部分 -->
      <div class="title">{{ title }}</div>
    </div>
    <!-- 右侧按钮部分 -->
    <div class="right btn" @click="GoLook()">可试看</div>
  </div>
</template>

<script>
export default {
  name: "tips",
  props: {
    // 试看对象
    obj: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 序列号
    MYnumber: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    // 训练营ID
    camp: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      // s试看类型
      type:null,
      // 试看标题
      title:null
    };
  },
  methods: {
    GoLook() {
      this.$router.push({
        path: `/Detail/LookImageText/${this.camp}`,
        query: {
          lesson_id: this.obj.lesson_id,
          camp: this.camp_id,
          pattern_id: this.obj.pattern_id,
          is_look:"1",
          isgood:this.obj.isgood
        },
      });
    },
  },
  mounted() {
    if (this.obj != null) {
      let num = this.obj.lesson_name.search(/】|]/);
      if (num != -1) {
        this.title = this.obj.lesson_name.slice(num+1)
        this.type = this.obj.lesson_name.slice(0,num+1)
      }else{
        this.title = this.obj.lesson_name
      }
    }
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.tips {
  padding: 0 1.4375rem 0 1.3125rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #f8f8f8;
  width: 100%;
  height: 4.375rem;
  border-bottom: 0.0625rem solid #ebebeb;
  // 左侧标题以及序号部分
  .left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.125rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    .number {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 1.75rem;
      height: 1.75rem;
      border-radius: 50%;
      border: 0.0625rem solid #ff7d3a;
      color: #fa864a;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #fa864a;
      flex-shrink: 0;
    }
    .type {
      margin-left: 0.1875rem;
      color: #ff7d3a;
      flex-shrink: 0;
    }
    .title {
      color: #000000;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }

  .right {
    margin-left: 0.625rem;
    flex-shrink: 0;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 4.625rem;
    height: 1.6875rem;
    background: #ffffff;
    border: 0.0625rem solid #ff7d3a;
    border-radius: 0.1875rem;
    font-size: 0.875rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ff945d;
  }
  .right:hover {
    text-decoration: underline;
  }
}
</style>